import VueVirtualScroller from 'vue-virtual-scroller';
import linkifyHtml from 'linkify-html';
import type { Plugin } from 'vue';
import { required, url } from '@vuelidate/validators';

import { i18n } from '@/i18n/i18n';
import PageTitle from '@/plugins/page-title';
import VueQuery from '@/plugins/vueQuery';

export default {
  install(app) {
    app.use(i18n);
    required.$message = i18n.global.t('global.validation.required');
    url.$message = i18n.global.t('global.validation.url');

    app.use(VueVirtualScroller);

    app.use(VueQuery);

    // Register custom @Plugins.
    app.use(PageTitle);

    app.directive('linkified', {
      beforeMount(element, binding) {
        element.innerHTML = linkifyHtml(element.innerHTML, {
          rel: 'noopener noreferrer',
          target: '_blank',
          ...binding.value,
        });
      },
      updated(element, binding) {
        element.innerHTML = linkifyHtml(element.innerHTML, {
          rel: 'noopener noreferrer',
          target: '_blank',
          ...binding.value,
        });
      },
    });
  },
} satisfies Plugin;
